const settings = {
  postCompanyUser(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    return this.request('/1/users/company/add_user', Object.assign(defaults, { data }));
  },

  getCompany(filterData) {
    const filter = filterData || '';
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/company?selected_company_id='.concat(filter), defaults);
  },
  /*
  getCompanyUsers(from_ldap, companyId, limit, page) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    const param = [];

    if (from_ldap) {
      param.push('fromLdap='.concat(from_ldap));
    }
    if (companyId) {
      param.push('selected_company_id='.concat(companyId));
    }

    if (limit) {
      param.push('limit='.concat(limit));
    }
    if (page) {
      param.push('page='.concat(page));
    }

    return this.request('/1/users/users?'.concat(param.join('&')), defaults);
  },
*/
  getCompanyUsers(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/users/users', Object.assign(defaults, { data }));
  },
  uploadLicenseKey(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/upload', Object.assign(defaults, { data }));
  },
  deleteCompanyUser(data) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/users/company/remove_user', Object.assign(defaults, { data }));
  },

  getAbout() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/show', defaults);
  },

  getCompanySettings() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/edit', defaults);
  },

  getQuota() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/quota', defaults);
  },
  getQuotaData() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/quota_balance', defaults);
  },
  getRecentData() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/recents', defaults);
  },

  getUploadedData(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/left_list', Object.assign(defaults, { data }));
  },

  getBookmarkData(page, limit) {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/bookmarks?page=${page}&limit=${limit}`, defaults);
  },
  getMyBookmarkData(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/bookmarks/list', Object.assign(defaults, { data }));
  },
  deleteMyBookmark(bookmarkId) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/bookmarks/${bookmarkId}`, defaults);
  },
  deleteMyRecentList(fileId) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/recents/${fileId}`, defaults);
  },
  createMyBookmark(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/bookmarks', Object.assign(defaults, { data }));
  },
  updateBookmarkView(data, bookmarkId) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/bookmarks/${bookmarkId}`, Object.assign(defaults, { data }));
  },

  reorderMyBookmark(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/bookmarks/reorder', Object.assign(defaults, { data }));
  },

  createCompanySettings(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/create', Object.assign(defaults, { data }));
  },

  updateCompanySettings(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/update', Object.assign(defaults, { data }));
  },

  removeCompany(companyId) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(
      '/1/customer_company/remove?selected_company_id='.concat(companyId),
      defaults
    );
  },

  getCompanyList(obj) {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    //pageNum, limitCnt

    const param = [];

    if (obj.pageNum) {
      param.push('page='.concat(obj.pageNum));
    }

    if (obj.limitCnt) {
      param.push('limit='.concat(obj.limitCnt));
    }

    if (obj.search) {
      param.push('search='.concat(obj.search));
    }

    return this.request('/1/customer_company?'.concat(param.join('&')), defaults);
  },

  getCompanyDetail(companyId) {
    const suffix = companyId ? '?selected_company_id='.concat(companyId) : '';
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/edit'.concat(suffix), defaults);
  },

  serverAddress(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/server_address', Object.assign(defaults, { data }));
  },

  getServerAddress() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/get_server_address', defaults);
  },

  mailer(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/mailer', Object.assign(defaults, { data }));
  },

  saveMailer(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/save_mailer', Object.assign(defaults, { data }));
  },

  useSmtp(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/use_smtp', Object.assign(defaults, { data }));
  },

  useLdap(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/use_ldap', Object.assign(defaults, { data }));
  },

  getLDAP() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/get_ldap', defaults);
  },

  saveLdap(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/save_ldap', Object.assign(defaults, { data }));
  },

  syncLdapUser() {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/sync_ldap_user', defaults);
  },

  updateProjectStatus(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml('/1/projects/change_status', Object.assign(defaults, { data }));
  },
  updateUserStatus(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml('/1/users/change_status', Object.assign(defaults, { data }));
  },
  deletSProject(data) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml('/1/projects/destroy_selected', Object.assign(defaults, { data }));
  },
  deletSUser(data) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml('/1/users/destroy_selected', Object.assign(defaults, { data }));
  },
  createSProject(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/projects', Object.assign(defaults, { data }));
  },
  updateProject(projectId, data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${projectId}`, Object.assign(defaults, { data }));
  },
  getsUploadedFileData(projectVersionId) {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(
      `/1/projects/versions/settings_uploaded?project_version_id=${projectVersionId}`,
      defaults
    );
  },
  getsProjectPolicyDetail(projectId) {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/projects/settings_policy?project_id=${projectId}`, defaults);
  },
  getsProjectPolicyMemberDetail(projectId) {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/projects/settings_member?project_id=${projectId}`, defaults);
  },
  getsPolicyCount() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/policies/settings', defaults);
  },
  getsGroupCount() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/groups/settings', defaults);
  },
  getsPolicyList(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/policies/settings', Object.assign(defaults, { data }));
  },
  getsGroupList(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/groups/local_settings', Object.assign(defaults, { data }));
  },
  getsLDAPList(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/groups/ldap_settings', Object.assign(defaults, { data }));
  },
  deletsGroup(data) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml('/1/groups/destroy_selected', Object.assign(defaults, { data }));
  },
  createSGroup(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/groups/company/add_group', Object.assign(defaults, { data }));
  },
  deletesPolicy(data) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml('/1/policies/destroy_selected', Object.assign(defaults, { data }));
  },
  searchGroupMember(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/groups/search-member', Object.assign(defaults, { data }));
  },
  searchPolicyComponent(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/policies/search-component', Object.assign(defaults, { data }));
  },
  searchPolicyVersion(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/policies/search-component-version', Object.assign(defaults, { data }));
  },
  searchPolicyRisk(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/policies/search-security', Object.assign(defaults, { data }));
  },
  searchPolicyLicense(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/policies/search-license', Object.assign(defaults, { data }));
  },
  searchPolicyHomepage(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/policies/search-homepage', Object.assign(defaults, { data }));
  },
  buildHomepageFromComponent(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/component_licenses/search-component-homepages', Object.assign(defaults, { data }));
  },
  searchDeclaredLicense(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects/search-license', Object.assign(defaults, { data }));
  },
  createPolicy(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/policies/company/add_policy', Object.assign(defaults, { data }));
  },

  getSPolicyDetail(policyId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/policies/${policyId}/edit`, defaults);
  },

  updatePolicyDetail(policyId, data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/policies/${policyId}`, Object.assign(defaults, { data }));
  },
  deletesPolicyDetail(policyId) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/policies/${policyId}`, defaults);
  },

  getSPolicyProjectDetail(policyId) {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/policies/settings_project?policy_id=${policyId}`, defaults);
  },
  getSGroupMemberDetail(groupId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/groups/settings_member?group_id=${groupId}`, defaults);
  },
  getSGroupProjectDetail(groupId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/groups/settings_project?group_id=${groupId}`, defaults);
  },
  getSLocalGroupDetail(groupId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/groups/${groupId}/edit`, defaults);
  },
  updateLocalGroupDetail(groupId, data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/groups/${groupId}`, Object.assign(defaults, { data }));
  },
  deleteGroup(groupId) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/groups/${groupId}`, defaults);
  },
  useUpdatersMenu() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/use_system_menu', defaults);
  },
  getUpdateInfo() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/updaters', defaults);
  },
  getUpdateStatus() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/updaters/update_status', defaults);
  },
  getOnlyUpdateStatus() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/updaters/only_update_status', defaults);
  },
  runUpdate() {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/updaters/run_update', defaults);
  },
  stopUpdate() {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/updaters/stop_update', defaults);
  },

  setUpdateConfig(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/updaters/update_setting', Object.assign(defaults, { data }));
  },

  setProxyConfig(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/updaters/update_proxy', Object.assign(defaults, { data }));
  },
  getProxyUrl(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/updaters/proxy', Object.assign(defaults, { data }));
  },
  ///1/updaters/proxy

  showUpdateLog() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/updaters/show_log', defaults);
  },

  getCurrentTimeZone() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/get_time_zone', defaults);
  },

  getTimeZoneList(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/get_time_zone_list', Object.assign(defaults, { data }));
  },

  setTimeZone(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/set_time_zone', Object.assign(defaults, { data }));
  },
  getDefinedResultList(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/defined_result_list', Object.assign(defaults, { data }));
  },
  deleteDefinedResult(data) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/defined_results', Object.assign(defaults, { data }));
  },
  createCustomerCompanyDefinedResult(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/defined_result', Object.assign(defaults, { data }));
  },
  updateCustomerCompanyDefinedResult(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/defined_result', Object.assign(defaults, { data }));
  },
  getIssueSetting() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/issues/setting', defaults);
  },
  setIssueSetting(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/issues/setting', Object.assign(defaults, { data }));
  },
  getsLDAPListWithSystems(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/ldaps/settings', Object.assign(defaults, { data }));
  },
  setSyncLDAPLatestStatus(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/ldaps/sync_selected', Object.assign(defaults, { data }));
  },
  updateOrderwithLDAPList(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/ldaps/reorder', Object.assign(defaults, { data }));
  },
  deleteLDAP(data) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/ldaps/destroy_selected', Object.assign(defaults, { data }));
  },
  addNewLDAP(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/ldaps', Object.assign(defaults, { data }));
  },
  getCurrentLdap(ldapId) {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/ldaps/${ldapId}/edit`, defaults);
  },
  updateCurrentLdap(ldapId, data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/ldaps/${ldapId}`, Object.assign(defaults, { data }));
  },
  updateLdapWithStatus(ldapId, data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/ldaps/${ldapId}/use_ldap`, Object.assign(defaults, { data }));
  },
  deleteCurrentLDAP(ldapId) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/ldaps/${ldapId}`, Object.assign(defaults));
  },
  getWebSecurity() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/get_web_security', defaults);
  },
  updateSessionTimeout(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/set_session_timeout', Object.assign(defaults, { data }));
  },
  updateMultipleSession(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/set_multiple_session', Object.assign(defaults, { data }));
  },
  updateRestrictOldPassword(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/set_restrict_old_password', Object.assign(defaults, { data }));
  },
  updatePasswordChangeCycle(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/set_password_change_cycle', Object.assign(defaults, { data }));
  },
  updateComplexPassword(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/set_complex_password', Object.assign(defaults, { data }));
  },
  updateIncativateAccount(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(
      '/1/customer_company/set_inactivate_account',
      Object.assign(defaults, { data })
    );
  },
  getLeakageStatus() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/use_leakage', defaults);
  },
  getUseCryptoStatus() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/use_crypto', defaults);
  },
  updateUseCryptoStatus(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/use_crypto', Object.assign(defaults, { data }));
  },
  updateLeakageStatus(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/use_leakage', Object.assign(defaults, { data }));
  },
  getUSerManualWithHeadless() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      responseType: 'arraybuffer',
    };
    return this.request('/1/help/headless', defaults, '', true);
  },
  getLocaleWithCompany() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/get_locale', defaults);
  },
  setLocaleWithCompany(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/set_locale', Object.assign(defaults, { data }));
  },
  getExportOptions() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/export_options/setting', defaults);
  },
  setExportOptions(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/export_options/setting', Object.assign(defaults, { data }));
  },
  getAwsCredential() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/aws_credential', defaults);
  },
  setAwsCredential(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/aws_credential', Object.assign(defaults, { data }));
  },
  getAwsBinary() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/aws_s3_binary', defaults);
  },
  setAwsBinary(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/aws_s3_binary', Object.assign(defaults, { data }));
  },
  getAwsSbom() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/aws_s3_sbom', defaults);
  },
  setAwsSbom(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/aws_s3_sbom', Object.assign(defaults, { data }));
  },
  searchCustomerCompanyDefinedResults(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/customer_company/search_defined_result', Object.assign(defaults, { data }));
  },
  getContinuousScanSettings() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/continuous_scans/setting', defaults);
  },
  setContinuousScanSettings(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/continuous_scans/setting', Object.assign(defaults, { data }));
  },
  getReleaseNotes(obj) {
    const page = obj.page || 1;
    const limit = obj.limit || 25;
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/customer_company/release_note?page=${page}&limit=${limit}`, defaults);
  },
  downloadReleaseNoteFile(obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      responseType: 'blob',
    };
    return this.request('/1/customer_company/release_note_file', Object.assign(defaults, { data }), '', true);
  },
};

export default settings;
